import {get,post} from '@/util/http';
import { Notification } from 'uiv'

const project = {
    state:{},
    mutations:{},
    actions:{
        async mainVideo({},params){//首页投洽会视频；关于投洽会宣传视频；新文中心宣传视频；资料中心；世界政要名流谈投洽会，点击后的视频
            const res = await get('/CifitSystem/api/datacenter/videoList/mainVideo.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async videoInfo({},params){//资料中心，视频点播和世界政要名流谈投洽会点击后的接口
            const res = await get('/CifitSystem/api/datacenter/videoList/videoInfo.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async hisPic({},params){//历届精彩图片分页查询
            const res = await get('/CifitSystem/api/datacenter/pastHighlights/findList.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async dataList({},params){//资料下载
            const res = await get('/CifitSystem/api/datacenter/dataDownload/dataList.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async hisList({},params){//历届回顾，一级接口
            const res = await get('/CifitSystem/api/datacenter/previousReviews/findList.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async hisdetail({},params){//历届回顾二级接口，详情
            const res = await get('/CifitSystem/api/datacenter/previousReviews/detail.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async lastReview({},params){//历史回顾（即上届回顾）
            const res = await get('/CifitSystem/api/datacenter/previousReviews/lastReview.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
    }
}

export default project


// WEBPACK FOOTER //
// ./src/store/modules/material.js